<app-icon
  [aria]="{ label: data.tooltip?.label }"
  [appTooltip]="data.tooltip"
  [colour]="data.colour"
  [icon]="data.icon"
  [margin]="data.margin"
  [size]="data.size"
/>
